var MentionsContextKey = Symbol('MentionsContextKey');
export default MentionsContextKey;